"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserActionAutoCaptureEvent = exports.AutoCaptureEventName = void 0;
exports.AutoCaptureEventName = {
    PAGE_VIEW: 'auto_capture::page_view',
    PAGE_VIEW_END: 'auto_capture::page_view_end',
    ERROR: 'auto_capture::error',
    SESSION_START: 'auto_capture::session_start',
    PERFORMANCE: 'auto_capture::performance',
    FORM_SUBMIT: 'auto_capture::form_submit',
    CLICK: 'auto_capture::click',
    RAGE_CLICK: 'auto_capture::rage_click',
    WEB_VITALS: 'auto_capture::web_vitals',
    DEAD_CLICK: 'auto_capture::dead_click',
    COPY: 'auto_capture::copy',
    // log line is a special event name used to populate logs metrics explorer
    CONSOLE_LOG: 'statsig::log_line',
};
const USER_ACTION_EVENTS = new Set([
    exports.AutoCaptureEventName.PAGE_VIEW,
    exports.AutoCaptureEventName.PAGE_VIEW_END,
    exports.AutoCaptureEventName.SESSION_START,
    exports.AutoCaptureEventName.FORM_SUBMIT,
    exports.AutoCaptureEventName.CLICK,
    exports.AutoCaptureEventName.RAGE_CLICK,
    exports.AutoCaptureEventName.COPY,
]);
const isUserActionAutoCaptureEvent = (eventName) => {
    return USER_ACTION_EVENTS.has(eventName);
};
exports.isUserActionAutoCaptureEvent = isUserActionAutoCaptureEvent;
